<template>
  <div>
    <b-jumbotron>
      <b-row>
        <font-awesome-layers full-width class="fa-3x logo">
          <font-awesome-icon icon="square" style="color: #4c7d7a" />
          <font-awesome-icon
            icon="stethoscope"
            transform="shrink-7"
            style="color: white"
          />
        </font-awesome-layers>
        <h5>Treatment Plan Requests</h5>
      </b-row>
    </b-jumbotron>
    <b-jumbotron>
      <b-row>
        <b-col>
          <label for="selectStatus">Status</label>
          <b-form-select
            size="sm"
            id="selectStatus"
            v-model="selectedStatus"
            :options="statusOptions"
          ></b-form-select>
        </b-col>
        <b-col>
          <label for="selectedCreatedIn">Created In</label>
          <b-form-select
            size="sm"
            id="selectedCreatedIn"
            v-model="selectedCreatedIn"
            :options="createdInOptions"
          ></b-form-select>
        </b-col>
        <b-col>
          <label for="selectedProcedure">Procedure</label>
          <b-form-select
            size="sm"
            id="selectedProcedure"
            v-model="selectedProcedure"
            :options="procedureOptions"
          ></b-form-select>
        </b-col>
        <b-col>
          <label for="filterInput">Search</label>
          <b-form-input
            size="sm"
            v-model="filter"
            type="search"
            id="filterInput"
            placeholder="Type to Search"
          ></b-form-input>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-form-checkbox style="margin-left: 1rem" id="idMyTpr" v-model="myTPR">
          <div style="margin-top: 3px">My TPR</div>
        </b-form-checkbox>
      </b-row>
    </b-jumbotron>
    <b-spinner
      variant="warning"
      class="m-5"
      style="width: 3rem; height: 3rem"
      v-if="showSpinner"
    />
    <div v-if="!showSpinner" style="margin: 0 1rem">
      <b-table
        id="idTreatmentPlanRequests"
        style="text-align: left"
        head-variant="light"
        outlined
        responsive
        hover
        selectable
        select-mode="single"
        small
        per-page="20"
        :items="requests"
        :fields="fields"
        :current-page="currentPage"
        :filter="filter"
        :filter-ignored-fields="ignoreFields"
        @filtered="onFiltered"
        @row-clicked="handleRowClick"
      >
        <template v-slot:cell(tprOpened)="row">
          <div
            style="
              display: block;
              margin-left: auto;
              margin-right: auto;
              width: 10%;
            "
          >
            <b-form-checkbox
              :disabled="
                !isInHouseUser ||
                selectedStatus === 'Created' ||
                selectedStatus === 'Rejected' ||
                selectedStatus === 'Cancelled'
              "
              size="lg"
              v-model="row.item.tprOpened"
              @change="onTprOpenedClicked(row.item)"
            ></b-form-checkbox>
          </div>
        </template>
      </b-table>
      <b-pagination
        id="idTreatmentPlanRequestPagination"
        style="margin-right: 1rem"
        v-model="currentPage"
        :total-rows="totalRows"
        first-number
        last-number
        per-page="20"
        align="right"
      />
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
export default {
  data() {
    return {
      showSpinner: true,
      requests: [],
      bearer: {},
      availableBranches: [],
      opts: {},
      filter: null,
      selectedStatus: null,
      ignoreFields: ["id", "dateTimeLastModified"],
      statusOptions: [
        { value: "Created", text: "Created" },
        { value: "Submitted", text: "Submitted" },
        { value: "InDesign", text: "In Design" },
        { value: "Rejected", text: "Rejected" },
        { value: "TreatmentPlanAvailable", text: "Treatment Plan Available" },
        { value: "TreatmentPlanDelivered", text: "Treatment Plan Downloaded" },
        { value: "Cancelled", text: "Cancelled" },
      ],
      selectedCreatedIn: "10",
      createdInOptions: [
        { value: "10", text: "Last 10 Days" },
        { value: "30", text: "Last 1 Month" },
        { value: "90", text: "Last 3 Months" },
      ],
      selectedProcedure: "all",
      procedureOptions: [
        { value: "all", text: "All" },
        { value: "MCKPK", text: "MCK Partial Knee" },
        { value: "TTK", text: "Triathlon Total Knee" },
        { value: "TH", text: "Total Hip" },
      ],
      myTPR: false,
      totalRows: 1,
      currentPage: 1,
      isInHouseUser: false,
    };
  },
  async created() {
    this.showSpinner = true;
    this.isInHouseUser =
      this.$store.state.roles?.includes("RH.MS.InhouseUser") &&
      !this.$store.state.roles?.includes("RH.MS.FieldUser");
    if (this.isInHouseUser) this.selectedStatus = "Submitted";
    else this.selectedStatus = "Created";
    // only get branches if user is not InHouseUser, InHouseUsers can see all requests
    if (!this.isInHouseUser) {
      try {
        // Get available Branches for the user
        const branchesResponse = await this.$buhApi.branchesUsersGet(
          this.$msal.data.user.userName
        );
        this.availableBranches = branchesResponse.branches.map((branch) => {
          return branch.name;
        });
      } catch (e) {
        this.$root.$emit("showAlert", {
          type: "error",
          msg: `The user "${this.$msal.data.user.userName}" is not set up yet, please contact your admin.`,
        });
      }
    }
    this.getTreatmentPlanRequests();
  },
  watch: {
    selectedStatus() {
      this.getTreatmentPlanRequests();
    },
    selectedCreatedIn() {
      this.getTreatmentPlanRequests();
    },
    selectedProcedure() {
      this.getTreatmentPlanRequests();
    },
    myTPR() {
      this.getTreatmentPlanRequests();
    },
  },
  computed: {
    fields() {
      let fields = [
        { key: "branch", sortable: true },
        { key: "tprId", sortable: true, label: "TPR ID" },
        { key: "hospitalName", sortable: true },
        { key: "surgeonName", sortable: true },
        {
          key: "surgeryStartDate",
          sortable: true,
          formatter: this.formatSurgeryDate,
          label: "Surgery Start Date",
        },
        { key: "primaryMps", sortable: true, label: "Primary MPS" },
        { key: "procedure", sortable: true },
        {
          key: "operativeSide",
          sortable: true,
          label: "Op Side (Right, Left)",
        },
        { key: "needByDate", sortable: true },
      ];

      if (this.isInHouseUser && this.selectedStatus === "Submitted") {
        fields.push({ key: "tprOpened", sortable: true, label: "TPR Opened" });
      }
      return fields;
    },
  },
  methods: {
    formatProcedureType(value) {
      if (!value) return "";
      return this.$store.getters.getProcedureText(value);
    },
    formatSurgeryDate(value) {
      if (value) {
        return moment(value).utc().format("M/D/YYYY");
      } else {
        return null;
      }
    },
    async onTprOpenedClicked(item) {
      const tprOpened = !item.tprOpened;
      const additionalDataResponse =
        await this.$additionalDataApi.treatmentplanrequestsIdAdditionalDataPatch(
          item.id,
          item.dateTimeLastModified,
          { tprOpened: tprOpened }
        );
      this.requests = this.requests.map((request) => {
        if (request.id === additionalDataResponse.requestId)
          request.dateTimeLastModified =
            additionalDataResponse.dateTimeLastModified;
        return request;
      });
    },
    getTreatmentPlanRequests() {
      this.showSpinner = true;
      const opts = {
        requestState: this.selectedStatus,
        dateTimeFrom: new Date(
          new Date().setDate(new Date().getDate() - this.selectedCreatedIn)
        ),
        pageSize: 0,
        includeAcknowledgedRequests: true,
      };
      if (this.selectedProcedure !== "all") {
        opts["applicationType"] = [this.selectedProcedure];
      }
      if (!this.isInHouseUser) {
        if (this.availableBranches.length === 0) {
          return;
        }
        opts["regions"] = this.availableBranches;
      }
      this.$treatmentPlanRequestsApi.treatmentplanrequestsGet(opts).then(
        (data) => {
          var cases = data.content
            .filter((item) => {
              if (this.myTPR) {
                if (
                  item.metadata.createdByUser === this.$msal.data.user.userName
                )
                  return item;
              } else {
                return item;
              }
            })
            .map((c) => {
              return {
                id: c.metadata.requestId,
                dateTimeLastModified: c.metadata.dateTimeLastModified,
                branch: c.region,
                tprId: c.externalReference,
                hospitalName:
                  _.has(c, "treatment.hospitalName") &&
                  c.treatment.hospitalName !== undefined &&
                  c.treatment.hospitalName !== null
                    ? c.treatment.hospitalName
                    : "",
                surgeonName:
                  _.has(c, "treatment.surgeonName") &&
                  c.treatment.surgeonName !== undefined &&
                  c.treatment.surgeonName !== null
                    ? c.treatment.surgeonName.firstName +
                      " " +
                      c.treatment.surgeonName.lastName
                    : "",
                surgeryStartDate:
                  _.has(c, "treatment.surgeryDate") &&
                  c.treatment.surgeryDate !== undefined &&
                  c.treatment.surgeryDate !== null
                    ? c.treatment.surgeryDate
                    : "",
                primaryMps:
                  _.has(c, "primaryContact") &&
                  c.primaryContact !== undefined &&
                  c.primaryContact !== null
                    ? c.primaryContact.firstName +
                      " " +
                      c.primaryContact.lastName
                    : "",
                procedure: _.has(c, "treatment.application.applicationType")
                  ? this.formatProcedureType(
                      c.treatment.application.applicationType
                    )
                  : "",
                operativeSide:
                  _.has(c, "treatment.operativeSide") &&
                  c.treatment.operativeSide !== undefined &&
                  c.treatment.operativeSide !== null
                    ? c.treatment.operativeSide.charAt(0).toUpperCase() +
                      c.treatment.operativeSide.slice(1)
                    : "",
                needByDate:
                  _.has(c, "needByDate") &&
                  c.needByDate !== undefined &&
                  c.needByDate !== null
                    ? moment(c.needByDate).format("M/D/YYYY")
                    : "",
                tprOpened: c.additionalData?.tprOpened,
              };
            });
          this.requests = cases;
          this.totalRows = cases.length;
          this.showSpinner = false;
        },
        (error) => {
          this.showSpinner = false;
          this.$root.$emit("showAlert", {
            type: "error",
            msg:
              "Error " +
              error.status +
              " while loading Treatment Plan Request List",
          });
        }
      );
    },
    handleRowClick(item) {
      this.$router.push({
        path: "treatmentPlanRequestDetails",
        query: { id: item.tprId },
      });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>

<style scoped>
#my-tpr {
  margin-left: 1rem;
}
.btn {
  margin-top: 1rem;
  position: absolute;
  right: 2rem;
}
</style>